import { TalentAgencyUsersList } from '@anytag/shared-organisms';
import { useTalentAgencyDetailsContext } from './TalentAgencyDetailsContext';

export const TalentAgencyUsers = () => {
  const { talentAgency } = useTalentAgencyDetailsContext();

  return <TalentAgencyUsersList talentAgencyId={talentAgency.id} />;
};
